/**
 * InstalmentsSection — Batch #14.329 : acomptes provisionnels d'un dossier fiscal (particuliers seulement), repliable.
 */
import { useState } from "react";
import { CalendarRange, ChevronDown, ChevronRight } from "lucide-react";
import InstalmentsCalculator from "@/components/instalments/InstalmentsCalculator";

export default function InstalmentsSection({ dossierId, masterId, clientName }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-slate-200 rounded-xl bg-white" data-testid="fiscal-instalments-section">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-2 p-5 text-left" data-testid="fiscal-instalments-toggle">
        <h2 className="font-semibold text-slate-800 flex items-center gap-2"><CalendarRange className="w-5 h-5 text-violet-600" />Acomptes provisionnels (particulier)</h2>
        <span className="text-xs text-slate-500 inline-flex items-center gap-1">{open ? "Replier" : "Calculer · plans enregistrés"}{open ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}</span>
      </button>
      {open && (
        <div className="px-5 pb-5 space-y-3">
          <p className="text-xs text-slate-600">Combien d'impôt le client a payé l'an dernier (fédéral · Québec) + % d'augmentation prévu → acomptes requis ?, trois méthodes et calendrier (15 mars · 15 juin · 15 septembre · 15 décembre). Le plan enregistré alimente le calendrier de conformité du client.</p>
          <InstalmentsCalculator scope="fiscal" fiscalDossierId={dossierId} masterId={masterId} defaultName={clientName || ""} />
        </div>
      )}
    </div>
  );
}
